import React from "react";

const Cookie = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                         <p className="text-dark fw-semibold opacity-50 mb-0">
              Effective Date: 10/08/2025
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-0">
              Company: TopCoin UK. Ltd
            </p>
             <p className="text-dark fw-semibold opacity-50 mb-0">
             Company Registeration No: 16483297
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-3">
              Contact: info@topcoinuk.com
            </p>
                 
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">1. Introduction  </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                 This Cookies Policy explains how Topcoin UK Ltd (“we”, “our”, “us”) uses cookies and similar tracking technologies on our website to improve your experience.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  2. What Are Cookies?  
                </h5>
                <p  className="info_description text-dark opacity-50 mb-0">Cookies are small text files stored on your device by your web browser. They help websites recognize your device and remember your preferences and actions.</p>
               
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">3. Types of Cookies We Use  </h5>               
                <ul className="text-dark opacity-50">
                  <li><strong>*Essential Cookies:* </strong>Necessary for website functionality such as login sessions and wallet access.</li>
                  <li><strong>*Performance Cookies:*</strong> Collect anonymous data about how visitors use our website to help us improve performance.  </li>
                  <li><strong>*Functional Cookies:*</strong> Remember your preferences (e.g., language, display settings).</li>
                  <li><strong>*Analytics Cookies:*</strong> Used to gather data about website traffic and usage patterns via third-party analytics tools.</li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                   4. How We Use Cookies  
                </h5>
              
                <p className="info_description text-dark opacity-50 mb-0">
                We use cookies to:  
                </p>
                <ul className="text-dark opacity-50">
                  <li>
                   Maintain secure login sessions for your wallet. 
                  </li>
                  <li>
                    Analyze website traffic to improve our services.  
                  </li>
                  <li>
                  Remember user preferences for a better browsing experience.  
                  </li>
                  <li>
                  Detect and prevent fraudulent activity.
                  </li>
                
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">5. Third-Party Cookies </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may use third-party services (e.g., Google Analytics) that set cookies to collect anonymous usage data. These third parties do not have access to your personal information.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                 6. Your Cookie Choices  
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Most browsers automatically accept cookies by default, but you can adjust your browser settings to:  
                </p>
                 <ul className="text-dark opacity-50">
                  <li>
                   Block all cookies.  
                  </li>
                  <li>
                    Delete cookies after each session.   
                  </li>
                  <li>
                 Receive warnings before accepting cookies.
                  </li>
                
                </ul>
                  <p className="info_description text-dark opacity-50 mb-0">
                  Please note that blocking cookies may affect your ability to use certain features of our website, including wallet access.
                </p>
              </li>
               <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">7. Changes to This Policy </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                 We may update this Cookies Policy to reflect changes in technology or legal requirements. Updates will be posted on this page.
                </p>
             
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">7. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                 If you have questions about our use of cookies, please contact us at: 
                </p>
                <ul className="info_description text-dark opacity-50 mb-0">
                  <li>
                    Email: <strong>info@topcoinuk.com</strong>
                  </li>
                 
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cookie;
